export interface LocalConfig {
  mode?: string;
  dashboardAPIHost?: string;
}
